import styled, { css } from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.button<{ tone: 'neutral' | 'danger' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: ${tokens.radius.sm};
  border: 1px solid transparent;
  background: transparent;
  color: ${tokens.color.textAsh};
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;

  &:hover:not(:disabled) {
    background: ${tokens.color.railGraphite};
    color: ${tokens.color.textWhite};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ tone }) =>
    tone === 'danger' &&
    css`
      color: ${tokens.color.errorRed};

      &:hover:not(:disabled) {
        background: ${tokens.color.errorRed};
        color: #fff;
      }
    `}
`;
